module.exports = __webpack_public_path__ + "static/img/2.70d56bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/eng/2.png
// module id = 6Yxr
// module chunks = 0